export const LOAD_CURRENCIES = 'LOAD_CURRENCIES'